<template>
<div class="chapter">
<div class="inner_page">
<p class="p6">For Laura and Amy, the best alpha-reading team a girl could ask for.</p>
<p class="p7"> </p>
<p class="p5">For Morgan, Bethany, and Amy for the moral support, and for Mada, who listened to my writing whine twice a week.</p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?7dddb0dc